<div class="add-products-modal">
  <div class="modal-header">
    <h2 class="modal-header__title">{{ title }}</h2>
    <button type="button" class="modal-header__close" (click)="onCancel()">
      <pdq-icon icon="close" size="medium"></pdq-icon>
    </button>
  </div>

  <div class="modal-body">
    <div class="modal-search-row">
      @if (isMultiSelect && !hideSelectAll && !canChooseOnlyOneProduct && !isLoading && products.length > 0) {
        <pdq-checkbox
          class="modal-select-all"
          label="Select all"
          labelSize="medium"
          [checked]="allSelected"
          (onChange)="toggleSelectAll()"></pdq-checkbox>
      }
      <div class="modal-search">
        <pdq-icon icon="search" size="small" class="modal-search__icon"></pdq-icon>
        <input
          type="text"
          class="modal-search__input"
          [placeholder]="searchPlaceholder"
          [ngModel]="searchQuery"
          (ngModelChange)="onSearchChange($event)" />
      </div>
    </div>

    <div class="modal-content">
      @if (isLoading) {
        <div class="loading-state">
          <span>Loading products...</span>
        </div>
      } @else if (products.length === 0) {
        <div class="empty-state">
          <span>No products found</span>
        </div>
      } @else {
        <div class="product-list">
          @for (product of products; track product.id) {
            <div
              class="product-row"
              [class.product-row--selected]="isSelected(product.id)"
              [class.product-row--locked]="isLocked(product.id)"
              (click)="onRowClick(product)">
              @if (isMultiSelect) {
                <div class="product-row__checkbox" (click)="$event.stopPropagation()">
                  <pdq-checkbox
                    [checked]="isSelected(product.id)"
                    [disabled]="isLocked(product.id)"
                    (onChange)="toggleProduct(product)">
                  </pdq-checkbox>
                </div>
              }
              <div class="product-row__image">
                @if (product.imageUrl) {
                  <img [src]="product.imageUrl" [alt]="product.title" />
                } @else {
                  <div class="product-row__placeholder">
                    <pdq-icon icon="cube" size="medium"></pdq-icon>
                  </div>
                }
              </div>
              <div class="product-row__info">
                <span class="product-row__title">{{ product.title }}</span>
                <span class="product-row__meta"
                  >SKU: {{ product.sku || 'N/A' }}
                  @if (product.price) {
                    &bull; ${{ product.price }}
                  }
                </span>
              </div>
              @if ((enableProductEdit && isSelected(product.id) && !isLocked(product.id)) || canOpenInShopify) {
                <div class="product-row__actions" (click)="$event.stopPropagation()">
                  @if (enableProductEdit && isSelected(product.id) && !isLocked(product.id)) {
                    <pdq-button
                      icon="edit-1"
                      variant="ghost"
                      [plain]="true"
                      size="small"
                      iconColor="var(--on-surface-light)"
                      ariaLabel="Edit product"
                      (onClick)="onEditProduct(product)">
                    </pdq-button>
                  }
                  @if (canOpenInShopify) {
                    <pdq-button
                      icon="go_to_order"
                      variant="ghost"
                      [plain]="true"
                      size="small"
                      iconColor="var(--on-surface-light)"
                      ariaLabel="Open in Shopify"
                      (onClick)="onOpenInShopify(product)">
                    </pdq-button>
                  }
                </div>
              }
            </div>
            @if (enableSpecificVariantSelection && isSelected(product.id) && hasSelectableVariants(product)) {
              <div class="product-variant-options">
                <pdq-dropdown
                  [coordinated]="true"
                  [options]="getSpecificVariantOptions(product)"
                  [defaultOption]="getSpecificVariantDefaultOption(product)"
                  [fullWidth]="true"
                  [title]="'Variant'"
                  [placeholder]="'All variants'"
                  (onChange)="onSpecificVariantChange(product.id, $event)">
                </pdq-dropdown>
              </div>
            }
            @if (enableVariants && isSelected(product.id) && hasRealVariants(product)) {
              <div class="product-variant-options">
                @for (option of product.options; track option.name) {
                  @if (canChooseOnlyOneProduct) {
                    <pdq-dropdown
                      [coordinated]="true"
                      [options]="getVariantDropdownOptions(product.id, option.name)"
                      [defaultOption]="getVariantSingleDefaultOption(product.id, option.name)"
                      [fullWidth]="true"
                      [title]="option.name"
                      [placeholder]="'Select ' + option.name"
                      (onChange)="onSingleVariantSelectionChange(product.id, option.name, $event)">
                    </pdq-dropdown>
                  } @else {
                    <pdq-dropdown
                      [coordinated]="true"
                      [options]="getVariantDropdownOptions(product.id, option.name)"
                      [defaultOption]="getVariantDefaultOptions(product.id, option.name)"
                      [multiSelect]="true"
                      [selectBy]="'checked'"
                      [fullWidth]="true"
                      [title]="option.name"
                      [placeholder]="'Please select'"
                      [showSelectUnselectOptions]="true"
                      [concatinatedLabelOptionsThreshold]="2"
                      [allSelectedText]="'All ' + option.name"
                      (onMultiSelectChange)="onVariantSelectionChange(product.id, option.name, $event)">
                    </pdq-dropdown>
                  }
                }
              </div>
            }
            @if (enableSellingPlans && isSelected(product.id)) {
              <div class="product-variant-options">
                @if (isLoadingSellingPlans(product.id)) {
                  <span class="product-variant-options__loading">Loading subscription plans...</span>
                } @else if (getSellingPlanOptions(product.id).length > 0) {
                  <pdq-dropdown
                    [coordinated]="true"
                    [options]="getSellingPlanOptions(product.id)"
                    [defaultOption]="getSellingPlanDefaultOptions(product.id)"
                    [multiSelect]="true"
                    [selectBy]="'checked'"
                    [fullWidth]="true"
                    [title]="'Subscription'"
                    [placeholder]="'Please select'"
                    [showSelectUnselectOptions]="true"
                    [concatinatedLabelOptionsThreshold]="2"
                    [allSelectedText]="'All plans'"
                    (onMultiSelectChange)="onSellingPlanSelectionChange(product.id, $event)">
                  </pdq-dropdown>
                } @else {
                  <span class="product-variant-options__loading"
                    >No subscription plans — offered as a one-time purchase.</span
                  >
                }
              </div>
            }
          }
        </div>
      }
    </div>
  </div>

  <div class="modal-footer">
    @if (isMultiSelect) {
      <span class="modal-footer__count"
        >{{ selectedCount }} {{ selectedCount === 1 ? 'Product' : 'Products' }} selected</span
      >
    }
    <div class="modal-footer__actions">
      <button type="button" class="btn-cancel" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn-select" [disabled]="isSelectDisabled" (click)="onAddProducts()">
        {{ addButtonText }}
      </button>
    </div>
  </div>
</div>
